interface NativeTokenData {
    address: string;
    blockchain: string;
    ticker: string;
}

export const changellyNativeTokensData: NativeTokenData[] = [
    {
        address: 'usei',
        blockchain: 'sei',
        ticker: 'sei'
    }
];
